import { ActivityCouponState } from '@tencent/wphk-act-base-types';

/** 状态排序次序 */
export const COUPON_SORT_STATE = [
  ActivityCouponState.expired,
  ActivityCouponState.used,
  ActivityCouponState.received,
  ActivityCouponState.totalLimit,
  ActivityCouponState.dayLimit,
  ActivityCouponState.avaliable,
];

